import React, { useState } from 'react';
// Importamos la función específica para el envío de recibos por WhatsApp
import { enviarReciboWhatsAppDirecto } from './whatsappService';

export default function AdminRevision({
  propietarios,
  enviarRecibosMasivosPorCorreo,
  limpiarPrevisualizacion,
  aprobarYEnviarRecibos,
  formatearMonto,
  enviarReciboIndividualPorCorreo,
  aprobarYEnviarReciboIndividual,
  edificioActual
}) {
  const [enviandoId, setEnviandoId] = useState(null);
  const [aprobandoId, setAprobandoId] = useState(null);
  const [enviandoWhatsAppId, setEnviandoWhatsAppId] = useState(null);

  // Estados para el Asistente de Envío Masivo por WhatsApp en Previsualización
  const [enviandoMasivoWhatsAppActivo, setEnviandoMasivoWhatsAppActivo] = useState(false);
  const [indiceMasivoWhatsAppActual, setIndiceMasivoWhatsAppActual] = useState(0);

  const manejarEnvioIndividual = async (prop) => {
    if (!prop.correo || !prop.correo.includes('@')) {
      alert("⚠️ Este propietario no tiene un correo electrónico válido registrado.");
      return;
    }
    
    if (window.confirm(`¿Deseas enviar el recibo de mantenimiento al Dpto. ${prop.departamento} (${prop.nombre})?`)) {
      try {
        setEnviandoId(prop.id);
        if (enviarReciboIndividualPorCorreo) {
          await enviarReciboIndividualPorCorreo(prop);
        } else {
          alert("⚠️ La función de envío individual aún no está conectada en el componente principal.");
        }
      } catch (error) {
        console.error("Error al enviar recibo individual:", error);
        alert("Hubo un error al enviar el correo.");
      } finally {
        setEnviandoId(null);
      }
    }
  };

  const manejarAprobarIndividual = async (prop) => {
    if (window.confirm(`¿Deseas aprobar, enviar y archivar el recibo del Dpto. ${prop.departamento} (${prop.nombre}) al Archivo Histórico?`)) {
      try {
        setAprobandoId(prop.id);
        if (aprobarYEnviarReciboIndividual) {
          await aprobarYEnviarReciboIndividual(prop);
        } else {
          alert("⚠️ La función de aprobación individual aún no está conectada en el componente principal.");
        }
      } catch (error) {
        console.error("Error al aprobar recibo individual:", error);
        alert("Hubo un error al aprobar y archivar el recibo.");
      } finally {
        setAprobandoId(null);
      }
    }
  };

  // Envío individual de aviso de recibo por WhatsApp
  const manejarWhatsAppReciboIndividual = async (prop) => {
    const telefonoRaw = prop.telefono || prop.celular;
    if (!telefonoRaw || telefonoRaw === '-' || telefonoRaw.trim() === '') {
      alert("⚠️ Este propietario no tiene un número de teléfono/celular registrado.");
      return;
    }

    const cuotaTexto = formatearMonto ? formatearMonto(prop.cuota) : `S/ ${prop.cuota || '0.00'}`;
    const nombreEdificio = edificioActual?.nombre || 'Edificio MMD&L';

    if (window.confirm(`¿Enviar estado de cuota por WhatsApp a ${prop.nombre} (${telefonoRaw})?`)) {
      try {
        setEnviandoWhatsAppId(prop.id);

        const resultado = await enviarReciboWhatsAppDirecto(
          telefonoRaw,
          prop.nombre,
          prop.departamento,
          prop.mes,
          prop.anio,
          cuotaTexto,
          prop.fechaEmision,
          prop.fechaVencimiento,
          prop.pdfUrl,
          nombreEdificio
        );

        if (resultado.success) {
          alert(`✅ ¡Aviso de recibo preparado y abierto con éxito para ${prop.nombre}!`);
        } else {
          throw new Error(resultado.error);
        }
      } catch (error) {
        console.error("Error al procesar WhatsApp de recibo:", error);
        alert(`❌ No se pudo procesar el WhatsApp: ${error.message}`);
      } finally {
        setEnviandoWhatsAppId(null);
      }
    }
  };

  // 🚀 Funciones para el Asistente Masivo de WhatsApp (Recibos)
  const iniciarEnvioMasivoWhatsApp = () => {
    if (!propietarios || propietarios.length === 0) {
      alert("⚠️ No hay recibos en la previsualización para enviar.");
      return;
    }
    setIndiceMasivoWhatsAppActual(0);
    setEnviandoMasivoWhatsAppActivo(true);
  };

  const procesarSiguienteYEnviarMasivoWhatsApp = async () => {
    const prop = propietarios[indiceMasivoWhatsAppActual];
    const telefonoRaw = prop.telefono || prop.celular;

    if (!telefonoRaw || telefonoRaw === '-' || telefonoRaw.trim() === '') {
      alert(`⚠️ El Dpto. ${prop.departamento} (${prop.nombre}) no tiene número registrado. Pasando al siguiente.`);
      avanzarMasivoWhatsApp();
      return;
    }

    const cuotaTexto = formatearMonto ? formatearMonto(prop.cuota) : `S/ ${prop.cuota || '0.00'}`;
    const nombreEdificio = edificioActual?.nombre || 'Edificio MMD&L';

    try {
      const resultado = await enviarReciboWhatsAppDirecto(
        telefonoRaw,
        prop.nombre,
        prop.departamento,
        prop.mes,
        prop.anio,
        cuotaTexto,
        prop.fechaEmision,
        prop.fechaVencimiento,
        prop.pdfUrl,
        nombreEdificio
      );

      if (!resultado.success) {
        console.warn(`Aviso de recibo Dpto ${prop.departamento}: ${resultado.error}`);
      }
    } catch (error) {
      console.error("Error en envío masivo WhatsApp de recibos:", error);
    }

    avanzarMasivoWhatsApp();
  };

  const avanzarMasivoWhatsApp = () => {
    if (indiceMasivoWhatsAppActual + 1 < propietarios.length) {
      setIndiceMasivoWhatsAppActual(prev => prev + 1);
    } else {
      setEnviandoMasivoWhatsAppActivo(false);
      alert("🎉 ¡Se ha recorrido toda la lista de recibos previsualizados con éxito!");
    }
  };

  const propietarioActualMasivo = propietarios[indiceMasivoWhatsAppActual];

  return (
    <div style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box', overflowX: 'hidden' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
        <h2 style={{ margin: 0, color: '#1e293b' }}>Previsualización y Aprobación</h2>
         
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <button onClick={enviarRecibosMasivosPorCorreo} style={{ backgroundColor: '#0284c7', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
            ✉️ Enviar a Todos por Correo
          </button>

          <button onClick={limpiarPrevisualizacion} style={{ backgroundColor: '#dc2626', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
            🗑️ Borrar Previsualización
          </button>

          <button onClick={aprobarYEnviarRecibos} style={{ backgroundColor: '#16a34a', color: 'white', border: 'none', padding: '10px 18px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
            🚀 Aprobar, Enviar y Archivar (Todos)
          </button>
        </div>
      </div>

      {/* SECCIÓN DEL ASISTENTE DE ENVÍO MASIVO DE RECIBOS POR WHATSAPP */}
      <div style={{ backgroundColor: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: '10px', padding: '20px', marginBottom: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px', boxSizing: 'border-box' }}>
        <div>
          <h4 style={{ margin: '0 0 5px 0', color: '#0369a1' }}>💬 Asistente de Envío Masivo de Recibos por WhatsApp</h4>
          <p style={{ margin: 0, fontSize: '0.85rem', color: '#0284c7' }}>Envía los estados de cuenta y montos del mes de manera guiada para todo el edificio.</p>
        </div>
        <div>
          {!enviandoMasivoWhatsAppActivo ? (
            <button 
              type="button" 
              onClick={iniciarEnvioMasivoWhatsApp} 
              style={{ backgroundColor: '#16a34a', color: 'white', border: 'none', padding: '10px 18px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}
            >
              💬 Iniciar Recibos Masivos WhatsApp ({propietarios.length} Recibos)
            </button>
          ) : (
            <button 
              type="button" 
              onClick={() => setEnviandoMasivoWhatsAppActivo(false)} 
              style={{ backgroundColor: '#dc2626', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.85rem' }}
            >
              ❌ Cerrar Asistente WhatsApp
            </button>
          )}
        </div>
      </div>

      {/* VENTANA FLOTANTE DEL ASISTENTE MASIVO DE RECIBOS */}
      {enviandoMasivoWhatsAppActivo && propietarios.length > 0 && (
        <div style={{ backgroundColor: '#ffffff', border: '2px solid #16a34a', borderRadius: '10px', padding: '20px', marginBottom: '25px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', boxSizing: 'border-box' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
            <span style={{ fontWeight: 'bold', color: '#16a34a', fontSize: '1rem' }}>
              📊 Progreso de Envío de Recibos: {indiceMasivoWhatsAppActual + 1} de {propietarios.length}
            </span>
            <span style={{ fontSize: '0.85rem', color: '#64748b' }}>Edificio: {edificioActual?.nombre}</span>
          </div>

          <div style={{ backgroundColor: '#f8fafc', padding: '15px', borderRadius: '8px', border: '1px solid #e2e8f0', marginBottom: '15px', boxSizing: 'border-box' }}>
            <p style={{ margin: '0 0 5px 0', fontSize: '1.1rem', fontWeight: 'bold', color: '#0f172a', wordBreak: 'break-word' }}>
              🏢 Departamento: {propietarioActualMasivo?.departamento} — {propietarioActualMasivo?.nombre}
            </p>
            <p style={{ margin: 0, color: '#64748b', fontSize: '0.9rem' }}>
              📱 Teléfono registrado: <strong>{propietarioActualMasivo?.telefono || propietarioActualMasivo?.celular || '⚠️ Sin teléfono'}</strong>
            </p>
          </div>

          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button 
              type="button"
              onClick={procesarSiguienteYEnviarMasivoWhatsApp}
              style={{ backgroundColor: '#25D366', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', flex: 1, fontSize: '0.95rem' }}
            >
              💬 Abrir WhatsApp y Pasar al Siguiente ➡️
            </button>
            <button 
              type="button"
              onClick={avanzarMasivoWhatsApp}
              style={{ backgroundColor: '#cbd5e1', color: '#334155', border: 'none', padding: '10px 15px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}
            >
              ⏭️ Saltar este
            </button>
          </div>
        </div>
      )}

      <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', borderRadius: '8px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
        <table className="tabla-propietarios" style={{ width: '100%', minWidth: '750px', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.9rem' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0', color: '#334155' }}>
              <th style={{ padding: '12px 14px' }}>Dpto.</th>
              <th style={{ padding: '12px 14px' }}>Propietario</th>
              <th style={{ padding: '12px 14px' }}>Correo</th>
              <th style={{ padding: '12px 14px' }}>Mes</th>
              <th style={{ padding: '12px 14px' }}>Año</th>
              <th style={{ padding: '12px 14px' }}>Cuota</th>
              <th style={{ padding: '12px 14px' }}>F. Emisión</th>
              <th style={{ padding: '12px 14px' }}>F. Vencimiento</th>
              <th style={{ padding: '12px 14px' }}>Recibo PDF</th>
              <th style={{ padding: '12px 14px' }}>Acción Individual</th>
            </tr>
          </thead>
          <tbody>
            {propietarios.length === 0 ? (
              <tr><td colSpan="10" style={{ textAlign: 'center', padding: '25px', color: '#666', backgroundColor: '#ffffff' }}>No hay registros en la previsualización actual.</td></tr>
            ) : (
              propietarios.map(prop => {
                const tienePdf = Boolean(prop.pdfUrl || (prop.pdfUrls && prop.pdfUrls.length > 0));

                return (
                  <tr key={prop.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                    <td style={{ padding: '12px 14px' }}>{prop.departamento}</td>
                    <td style={{ padding: '12px 14px', wordBreak: 'break-word' }}>{prop.nombre}</td>
                    <td style={{ padding: '12px 14px', wordBreak: 'break-all' }}>{prop.correo || 'Sin correo'}</td>
                    <td style={{ padding: '12px 14px' }}><strong>{prop.mes || '-'}</strong></td>
                    <td style={{ padding: '12px 14px' }}><strong>{prop.anio || '-'}</strong></td>
                    <td style={{ padding: '12px 14px' }}>{formatearMonto(prop.cuota)}</td>
                    <td style={{ padding: '12px 14px' }}>{prop.fechaEmision || '-'}</td>
                    <td style={{ padding: '12px 14px' }}>{prop.fechaVencimiento || '-'}</td>
                    <td style={{ padding: '12px 14px' }}>
                      {prop.pdfUrls && prop.pdfUrls.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          {prop.pdfUrls.map((pdf, idx) => (
                            <a key={idx} href={pdf.url || pdf} target="_blank" rel="noopener noreferrer" style={{ backgroundColor: '#0284c7', color: 'white', padding: '3px 8px', borderRadius: '4px', fontSize: '0.70rem', fontWeight: 'bold', textDecoration: 'none', display: 'inline-block', whiteSpace: 'nowrap' }}>
                              👁️ Ver PDF {idx + 1} ↗
                            </a>
                          ))}
                        </div>
                      ) : prop.pdfUrl ? (
                        <a href={prop.pdfUrl} target="_blank" rel="noopener noreferrer" style={{ backgroundColor: '#0284c7', color: 'white', padding: '5px 10px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 'bold', textDecoration: 'none', display: 'inline-block', whiteSpace: 'nowrap' }}>
                          👁️ Ver PDF ↗
                        </a>
                      ) : (
                        <span style={{ color: '#d9534f', fontStyle: 'italic', fontSize: '0.80rem', fontWeight: 'bold' }}>Falta PDF</span>
                      )}
                    </td>
                    <td style={{ padding: '12px 14px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', minWidth: '135px' }}>
                        {/* Botón de Correo / Notificar */}
                        <button 
                          onClick={() => manejarEnvioIndividual(prop)}
                          disabled={enviandoId === prop.id || !tienePdf}
                          style={{ 
                            backgroundColor: tienePdf ? '#0284c7' : '#94a3b8', 
                            color: 'white', 
                            border: 'none', 
                            padding: '5px 8px', 
                            borderRadius: '4px', 
                            fontSize: '0.70rem', 
                            fontWeight: 'bold', 
                            cursor: tienePdf ? 'pointer' : 'not-allowed',
                            whiteSpace: 'nowrap'
                          }}
                          title={tienePdf ? "Solo enviar notificación por correo" : "Se requiere PDF"}
                        >
                          {enviandoId === prop.id ? '⏳ Enviando...' : '✉️ Notificar Correo'}
                        </button>

                        {/* Botón de WhatsApp Individual para Recibos (VALIDADO CON TIENEPDF) */}
                        <button 
                          onClick={() => manejarWhatsAppReciboIndividual(prop)}
                          disabled={enviandoWhatsAppId === prop.id || !tienePdf}
                          style={{ 
                            backgroundColor: tienePdf ? '#16a34a' : '#94a3b8', 
                            color: 'white', 
                            border: 'none', 
                            padding: '5px 8px', 
                            borderRadius: '4px', 
                            fontSize: '0.70rem', 
                            fontWeight: 'bold', 
                            cursor: tienePdf ? 'pointer' : 'not-allowed',
                            whiteSpace: 'nowrap'
                          }}
                          title={tienePdf ? "Enviar estado de cuenta y recibo por WhatsApp" : "Se requiere PDF"}
                        >
                          {enviandoWhatsAppId === prop.id ? '⏳ Abriendo...' : '💬 WhatsApp Recibo'}
                        </button>

                        {/* Botón de Aprobar y Archivar */}
                        <button 
                          onClick={() => manejarAprobarIndividual(prop)}
                          disabled={aprobandoId === prop.id || !tienePdf}
                          style={{ 
                            backgroundColor: tienePdf ? '#16a34a' : '#94a3b8', 
                            color: 'white', 
                            border: 'none', 
                            padding: '5px 8px', 
                            borderRadius: '4px', 
                            fontSize: '0.70rem', 
                            fontWeight: 'bold', 
                            cursor: tienePdf ? 'pointer' : 'not-allowed',
                            whiteSpace: 'nowrap'
                          }}
                          title={tienePdf ? "Aprobar, enviar correo y archivar individualmente" : "Se requiere PDF"}
                        >
                          {aprobandoId === prop.id ? '⏳ Procesando...' : '🚀 Aprobar y Archivar'}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}